import { render } from "./copyProjectDialog.vue?vue&type=template&id=da486904"
import script from "./copyProjectDialog.vue?vue&type=script&lang=js"
export * from "./copyProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__